import http from "../utils/http";

function articleList(data) {
  return http.post("article_list", data);
}

export default articleList;
